// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"604":"40699213","787":"aab8bd84"}[chunkId] + ".chunk.js";
};